import Packlink from '@sdk';

import { Client } from '@packlink/packlink-sdk';

import { ReduxDispatch, ReduxAction } from '@store';

import { SET_CLIENT } from './action-types';

export interface ISetClientAction {
    type: 'SET_CLIENT';
    payload: Client;
}

export type ClientAction = ISetClientAction;

export const setClientAction = (data: Client): ISetClientAction => ({ type: SET_CLIENT, payload: data });

export const getClientAction =
    (): ReduxAction<Promise<Client | void>> =>
    async (dispatch: ReduxDispatch): Promise<Client | void> => {
        return Packlink.v1.clients.get().then((client: Client) => {
            dispatch(setClientAction(client));
            return client;
        });
    };
